import React, { useEffect, useState } from 'react';
import { createMuiTheme, createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from 'react-select';
import { Typography } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core';
import AddToListModal from "./addToListModal";
import { TOGGLE_GROWING_LIST_POPUP } from '../../Redux/actions';
import { useDispatch } from 'react-redux';

const theme = createMuiTheme({
    overrides: {
        // root: {
        //     color: 'green',
        //     '& label.Mui-focused': {
        //         color: 'green',
        //     },
        //     '& .MuiInput-underline:after': {
        //         borderBottomColor: 'green',
        //     },
        //     '& .MuiOutlinedInput-root': {
        //         '& fieldset': {
        //             borderColor: 'red',
        //         },
        //         '&:hover fieldset': {
        //             borderColor: 'yellow',
        //         },
        //         '&.Mui-focused fieldset': {
        //             borderColor: 'green',
        //         },
        //     },
        // },
    },
});
const useStyles = makeStyles((theme: Theme) =>

    createStyles({
        root: {
            // color: 'green',
            // '& label.Mui-focused': {
            //     color: 'green',
            // },
            // '& .MuiInput-underline:after': {
            //     borderBottomColor: 'green',
            // },
            // '& .MuiOutlinedInput-root': {
            //     '& fieldset': {
            //         borderColor: 'red',
            //     },
            //     '&:hover fieldset': {
            //         borderColor: 'yellow',
            //     },
            //     '&.Mui-focused fieldset': {
            //         borderColor: 'green',
            //     },
            // },
        },
        formControl: {
            width: "100%",
        },
        whiteColor: {
            color: "red"
        },


    }),
);


function CustomSelectMulti(props: any) {
    // console.log(props)
    const classes = useStyles();
    const [selectedValue, setSelectedValue] = React.useState("");
    const [showModal, setShowModal] = useState(false);
    const [postData, setPostData] = useState({});
    const dispatch = useDispatch();
    const selectOptionValues =  props.itemArr && props.itemArr.map((row: any)=>row.id);

    const {
        label,
        type,
        selectOptions,
        name,
        placeholder,
        required,
        defaultValue,
        disabled,
        readOnly,
        error,
        helperText,
        autoComplete,
        autoFocus,
        classNames,
        rows,
        rowsMax,
        color,
        value,
        apiVariable,
        params,
        handleChange,
        index,
        dropDown,
        field_name,
        isDynamicField
      } = props.componentObject;

    const handleAddNew = (event:any) => {
        event.preventDefault();
          setPostData({ drop_down: dropDown, field_name: field_name });
          setShowModal(true);
          console.log('trigger :>> ', "trigger");
          dispatch({type: TOGGLE_GROWING_LIST_POPUP, payload: true});
      };
    // const handleChange = (event: any) => {
    //     var localArr = [];
    //     localArr = event.length > 0 && event.filter((option: any) => option.value == "Add New")
    //     if (localArr.length > 0) {
    //         setShowModal(true)
    //         setPostData({ drop_down: props.drop_down, field_name: props.field_name });
    //         dispatch({ type: TOGGLE_GROWING_LIST_POPUP, payload: true });
    //         props.addNewHandler(props.addNewFlag, true, props);
    //     } else {
    //         props.parentcall(event, props.id)
    //     }
    // };
    useEffect(() => {
        props.defaultValue != undefined && setSelectedValue(props.defaultValue)
        props.itemArr?.map((option: any) => option['label'] = option.value)
        
    }, [props])
// console.log('props.itemArr?.map((option: any) ', props.itemArr?.map((option: any) => option['label'] = option.value));
// console.log('selectedValue :>> ', selectedValue);
    return (
        <FormControl variant={props.variant} className={classes.formControl} error={props.error}>
            <Select
                // onChange={handleChange}\
                onChange={(e,newValue) => {
                    console.log('newValue :>> ', e);
                    //  props.parentcall(newValue, props.id);
                    // e.target.value === 'Add New' ? handleAddNew(e)
                      handleChange(e, index)
        //               setInputValue(newValue)
        //               if(e.length > 0 && e.indexOf("+Add New") !== -1){
        //    handleAddNew(e);
        //               setShowModal(true)
        //               }
                    }}
                {...props}
                isMulti
                // value={props.value}
                name="colors"
                options={selectOptionValues}
                defaultValue={props.value}
                className="basic-multi-select"
                classNamePrefix="select"

                
               
            />
            {showModal && <AddToListModal postData={postData} />}


            {
                props.helperText && <FormHelperText>{props.helperText}</FormHelperText>
            }
        </FormControl>
    )
}

export default CustomSelectMulti
